import { create } from 'zustand';

interface ApartmentViewerState {
    noViews: boolean;
    setNoViews: (noViews: boolean) => void;
    reset: () => void;
}

export const useApartmentViewerStore = create<ApartmentViewerState>((set) => ({
    noViews: true,
    setNoViews: (noViews) => set({ noViews }),
    reset: () => set({ noViews: true }),
}));

// Selectors
export const selectNoViews = (state: ApartmentViewerState) => state.noViews;
